import React, { useState } from 'react'
import FooterManagement from '../components/FooterManagement/FooterManagement'

const FooterManagementPage = () => {
  return (
    <>
      <FooterManagement />
    </>
  )
}

export default FooterManagementPage
